module.exports = {
      id: "launcher-usage",
      viewBox: "0 0 28 28",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#launcher",
      toString: function () {
        return this.url;
      }
    }